import { getContractDetailsEndpoint } from './contracts';

export function getAmortizationDetailsEndpoint(contractId: string): string {
    return `${getContractDetailsEndpoint(contractId)}/amortization-details`;
}
